import { render, staticRenderFns } from "./DelegationOrderNewView.vue?vue&type=template&id=7f03154a&scoped=true&"
import script from "./DelegationOrderNewView.vue?vue&type=script&lang=js&"
export * from "./DelegationOrderNewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f03154a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f03154a')) {
      api.createRecord('7f03154a', component.options)
    } else {
      api.reload('7f03154a', component.options)
    }
    module.hot.accept("./DelegationOrderNewView.vue?vue&type=template&id=7f03154a&scoped=true&", function () {
      api.rerender('7f03154a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation-order/DelegationOrderNewView.vue"
export default component.exports